import { render } from "./Balken.vue?vue&type=template&id=29776570&scoped=true"
import script from "./Balken.vue?vue&type=script&lang=js"
export * from "./Balken.vue?vue&type=script&lang=js"

import "./Balken.vue?vue&type=style&index=0&id=29776570&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/inclusion_score/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29776570"]])

export default __exports__